export enum UserRolesEnum {
    Vendor = 1,
    Adjuster = 2,
    Admin = 3,
    VendorApi = 4,
    TerraclaimBot = 5,
    TenantAdmin = 6,
    TcMainAdmin = 7,
}
